import { FocusContext, setFocus, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import TransparentButton from '../../components/Buttons/TransparentButton';
import createTranslateFunction from '../../i18n/createTranslateFunction';
import React, { SetStateAction, useState } from 'react';
import { PickACardModal } from './PickACardModal';
import {
    UpdateDeliveryFormData,
    UpdateDeliveryFormDataType,
} from '../../redux/slices/deliveryFormSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch, useSelector } from '../../redux/store';
import { fetchMe } from '../../redux/slices/userAuthSlice';
import { Loading } from '../../components/Loading';

type PickACardScreenProps = {
    focusKey: string;
    isPickACardModalOpen: boolean;
    setIsPickACardModalOpen: React.Dispatch<SetStateAction<boolean>>;
};
const PickACardScreen = ({
    focusKey: focusKeyParam,
    isPickACardModalOpen,
    setIsPickACardModalOpen,
}: PickACardScreenProps) => {
    const PickAcardTranslateFunction = createTranslateFunction('choose_payment.pick_a_card');
    // const paymentCard = useSelector((state) => state.deliveryFormData.deliveryForm.payment_card);
    // const paymentLink = useSelector((state) => state.deliveryFormData.deliveryForm.payment_link);

    const dispatch = useDispatch<AppDispatch>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { ref, focusKey } = useFocusable({
        focusable: true,
        focusKey: focusKeyParam,
        preferredChildFocusKey: 'phonenumber-login-input',
    });

    const handleCvvPayment = async () => {
        console.log('Pressed on pay now!');
    };

    const handleDeliveryFormUpdation = (updates: UpdateDeliveryFormDataType) => {
        dispatch(UpdateDeliveryFormData(updates));
    };

    const openPickACardModal = async () => {
        setIsLoading(true);
        //Fetch user data to ensure updated payment cards are available
        await dispatch(fetchMe());
        setIsLoading(false);
        // Open the Pick A Card modal
        setIsPickACardModalOpen(true);
        setFocus('pick-a-card-modal');
    };

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} className="flex flex-col items-center pt-[3vw] h-[60%]">
                {isLoading && <Loading />}
                {isPickACardModalOpen && (
                    <PickACardModal
                        focusKey="pick-a-card-modal"
                        handleDeliveryFormUpdation={handleDeliveryFormUpdation}
                        close={() => setIsPickACardModalOpen(false)}
                        opened={isPickACardModalOpen}
                    />
                )}
                <span
                    className={`text-[2vw] mb-[6vw]`}
                >{`${PickAcardTranslateFunction(`title`)}`}</span>
                <span className="text-[1.4vw] max-w-[24vw] text-center mb-[4vw]">{`${PickAcardTranslateFunction(`description`)}`}</span>
                <div className="flex flex-col justify-center items-center">
                    <TransparentButton
                        className="flex justify-center items-center mb-[3vw] w-[14vw] h-[5vw] !text-[1.4vw]"
                        onClick={openPickACardModal}
                    >
                        {PickAcardTranslateFunction('pick_a_card_modal_title')}
                    </TransparentButton>
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default PickACardScreen;
